/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { Grid, Box, Typography, makeStyles } from "@material-ui/core";
import { getData, getPercent } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { CustomPieChart } from "../../../../../components/charts";
import { NoDataCard } from "../../../../../components/parts";

const useStyles = makeStyles(() => ({
  connections: {
    marginLeft: 30,
    paddingTop: 20,
    marginBottom: 30,
  },
  text: {
    fontWeight: 700,
    textAlign: "center",
    marginBottom: 30,
  },
  box: {
    height: 260,
  },
  nodata: {
    paddingTop: 0,
    paddingBottom: 46,
  },
}));

export const ComplexTenantsElectricityConnectionStatus = ({ complex }) => {
  const classes = useStyles();
  const [totalTenantsIn, setTotalTenantsIn] = useState();
  const [chartDataIn, setChartDataIn] = useState();
  const [totalBuildingsIn, setTotalBuildingsIn] = useState();
  const [totalTenantsCn, setTotalTenantsCn] = useState();
  const [chartDataCn, setChartDataCn] = useState();
  const [totalBuildingsCn, setTotalBuildingsCn] = useState();

  useEffect(() => {
    getData(`/praas/v2/complexes/${complex.id}/tenants/connection/individual/`, (data) => {
      setTotalTenantsIn(data.tenants.total_tenants);
      setTotalBuildingsIn(data.total_building);

      if (data.tenants.total_tenants > 0) {
        setChartDataIn([
          {
            name: "Fully Connected",
            value: data.tenants?.fully_connected || 0,
            key: "fully_connected",
            centerLabel: "are fully",
            centerSuffixLabel: "connected",
            color: COLORS.green,
            unit: "%",
            value_position: "inline",
            value_percent: data.tenants?.fully_connected
              ? getPercent(data.tenants?.fully_connected, data.tenants.total_tenants)
              : 0,
          },
          {
            name: "Partially Connected",
            value: data.tenants?.partially_connected || 0,
            key: "partially_connected",
            centerLabel: "are partially",
            centerSuffixLabel: "connected",
            color: COLORS.purple,
            unit: "%",
            value_position: "inline",
            value_percent: data.tenants?.partially_connected
              ? getPercent(data.tenants?.partially_connected, data.tenants.total_tenants)
              : 0,
          },
          {
            name: "Unconnected",
            value: data.tenants?.unconnected || 0,
            key: "unconnected",
            centerLabel: "are",
            centerSuffixLabel: "unconnected",
            color: COLORS.red,
            unit: "%",
            value_position: "inline",
            value_percent: data.tenants?.unconnected
              ? getPercent(data.tenants?.unconnected, data.tenants.total_tenants)
              : 0,
          },
        ]);
      }
    });
    getData(`/praas/v2/complexes/${complex.id}/tenants/connection/central/`, (data) => {
      setTotalTenantsCn(data.tenants.total_tenants);
      setTotalBuildingsCn(data.total_building);

      if (data.tenants.total_tenants > 0) {
        setChartDataCn([
          {
            name: "Fully Connected",
            value: data.tenants?.fully_connected || 0,
            key: "fully_connected",
            centerLabel: "are fully",
            centerSuffixLabel: "connected",
            color: COLORS.green,
            unit: "%",
            value_position: "inline",
            value_percent: data.tenants?.fully_connected
              ? getPercent(data.tenants?.fully_connected, data.tenants.total_tenants)
              : 0,
          },
          {
            name: "Partially Connected",
            value: data.tenants?.partially_connected || 0,
            key: "partially_connected",
            centerLabel: "are partially",
            centerSuffixLabel: "connected",
            color: COLORS.purple,
            unit: "%",
            value_position: "inline",
            value_percent: data.tenants?.partially_connected
              ? getPercent(data.tenants?.partially_connected, data.tenants.total_tenants)
              : 0,
          },
          {
            name: "Unconnected",
            value: data.tenants?.unconnected || 0,
            key: "unconnected",
            centerLabel: "are",
            centerSuffixLabel: "unconnected",
            color: COLORS.red,
            unit: "%",
            value_position: "inline",
            value_percent: data.tenants?.unconnected
              ? getPercent(data.tenants?.unconnected, data.tenants.total_tenants)
              : 0,
          },
        ]);
      }
    });
    return () => {
      setTotalTenantsIn();
      setChartDataIn();
      setTotalBuildingsIn();
      setTotalTenantsCn();
      setChartDataCn();
      setTotalBuildingsCn();
    };
  }, []);

  return (
    <ShaDowBox container>
      <Typography className={classes.connections} variant="h4">
        Tenants PRaaS-Connection Status
      </Typography>
      <Grid container>
        <Box style={{ width: "50%" }}>
          {totalTenantsIn && chartDataIn ? (
            <Grid item xs={12}>
              <Typography className={classes.text}>
                In Buildings with Individual meters ({totalBuildingsIn})
              </Typography>
              <Box className={classes.box}>
                <CustomPieChart name="ConnectionStatus" data={chartDataIn} />
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} className={classes.nodata}>
              <NoDataCard type="pie" withShaDowBox={false} className={classes.nodata} />
            </Grid>
          )}
        </Box>

        <Box style={{ width: "50%" }}>
          {totalTenantsCn && chartDataCn ? (
            <Grid item xs={12}>
              <Typography className={classes.text}>
                In Buildings with Central meters ({totalBuildingsCn})
              </Typography>
              <Box className={classes.box}>
                <CustomPieChart name="ConnectionStatus" data={chartDataCn} />
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} className={classes.nodata}>
              <NoDataCard type="pie" withShaDowBox={false} />
            </Grid>
          )}
        </Box>
      </Grid>
    </ShaDowBox>
  );
};
